// Error state for the queue tabs, with an explicit Retry action.
//
// A failed request must not fall through to the empty state ("No outstanding
// no-shows"), which reads as "nothing to do" and hides a stale or non-zero
// badge. The retry button re-runs the query so the user can recover without a
// full page reload.

type Props = { message: string; onRetry: () => void };

const QueueError = ({ message, onRetry }: Props) => (
  <div className="dashv2-queue-empty">
    <p>{message}</p>
    <button type="button" className="dashv2-retrybtn" onClick={onRetry}>
      Retry
    </button>
  </div>
);

export default QueueError;
